<template>
  <div class="index_box">
    <div class="hallPage">
      
      <div data-v-787526de="" class="hall-head">
        <img data-v-787526de="" src="/static/img/wdlogo.png">
        <div data-v-787526de="" class="accounts-head-text"> 大厅 </div>
        <a data-v-787526de="" target="_blank" href="javascript:;" class="download-link">
          <img data-v-787526de="" src="/static/img/download.de5120fd.gif">
        </a>
      </div>
      
      <div class="maincontent">
        <div class="hallinner">
          <div class="van-pull-refresh">
            <div class="van-pull-refresh__track" style="transition-duration: 0ms">
              <div class="van-pull-refresh__head" style="height: 80px"></div>
              <div class="toppart">
                <div class="outerbox">
                  <van-swipe @change="onChange" :autoplay="5000" :show-indicators="true">
                    <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                      <img :src="item.src" style="width: 100%" alt="" />
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <div class="noticecontent">
                  <img
                    src="/static/img/laba.png"
                  />
                  <div class="noticect">
                    <van-notice-bar color="#535a73" scrollable
                      ><span
                        v-for="(item, index) in homenoticelis"
                        @click="openGogao(item)"
                        :key="index"
                        >{{ item }}</span
                      ></van-notice-bar
                    >
                  </div>
                </div>
                <div class="centerArea">
                  <div class="left_content" v-if="$store.state.token">
                    <div class="logindd logindd1">
                      <!---->
                      {{ $store.state.userInfo.username }}
                    </div>
                    <div class="logindd logindd2">
                      ¥ {{ $store.state.userInfo.balance }}
                      <div class="money_text"></div>
                    </div>
                  </div>
                  
                  <div v-else class="loginbtn" @click="$parent.goNav('/login')">
                    <div class="loginbtn1"  @click="$parent.goNav('/login')"></div>
            <div class="mey">请先登录或者注册</div>
                  </div>
                 
                  
                  
                  
                  
                  
                  <!---->
                  <div class="right_content">
                    <!-- <div class="right_item">
                      <img
                        src="data:image/png;base64,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"
                      />
                      <div class="right_item_span">邀请</div>
                    </div> -->
                    <div class="right_item" @click="$parent.goNav('/recharge')">
                      <img src="/static/img/cz.png" />
                      <div class="right_item_span">充值</div>
                    </div>
                    
                      <div class="right_item" @click="$parent.goNav('/transfer')">
                      <img src="/static/img/zz.png" />
                      <div class="right_item_span">转账</div>
                    </div>
                    <div class="right_item" @click="$parent.goNav('/vip2')">
                      <img src="/static/img/vip.png" />
                      <div class="right_item_span">VIP</div>
                    </div>
                    <div class="right_item" @click="$parent.goNav('/withdrawal')">
                      <img src="/static/img/tx.png" />
                      <div class="right_item_span">提现</div>
                    </div>
                    <!-- <div class="right_item" @click="$parent.goNav('/transfer')">
                      <img src="/static/img/zhimg_gz.3bc32694.png" />
                      <div class="right_item_span">转账</div>
                    </div>
                    <div class="right_item" @click="$parent.goNav('/withdrawal')">
                      <img src="/static/img/tximg_gz.168bc81d.png" />
                      <div class="right_item_span">提现</div>
                    </div> -->
                    <!----><!---->
                  </div>
                </div>
              </div>
              <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
        <i @click="$parent.goNav('/hongbao')" class="grab"></i>
        <img @click="changhongbashow" src="/static/image/activity_close.a415a5d3.png" />
      </div>
      <div id="redPacket1" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
        <i @click="$parent.goNav('/activity')" class="grab"></i>
        <img @click="changhongbashow" src="/static/image/activity_close.a415a5d3.png" />
      </div>
      <div id="redPacket2" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
        <i @click="$parent.goav('/DW')" class="grab"></i>
        <img @click="changhongbashow" src="/static/image/activity_close.a415a5d3.png" />
      </div>
      
      
            <div data-v-d56ea1b0="" class="gamenavs short" style="position: unset;">
              <div data-v-d56ea1b0="" @click="type=0" class="gamenav" :class="{gamenavac:type==0}">  </div>
                <div data-v-d56ea1b0="" @click="type=1" class="gamenav1" :class="{gamenavac1:type==1}">  </div>
                <div data-v-d56ea1b0="" @click="type=2" class="gamenav2" :class="{gamenavac2:type==2}"> </div>
                <div data-v-d56ea1b0="" @click="type=3" class="gamenav3" :class="{gamenavac3:type==3}">  </div>
                <div data-v-d56ea1b0="" @click="type=5" class="gamenav4" :class="{gamenavac4:type==5}">  </div>
                <div data-v-d56ea1b0="" @click="type=4" class="gamenav5" :class="{gamenavac5:type==4}"> </div>
                <div data-v-d56ea1b0="" @click="type=6" class="gamenav6" :class="{gamenavac6:type==6}"> </div>
                
            </div>

              <!-- <div class="line"></div> -->
              
              <div class="hall">
              <!-- 这里 -->
                <div v-if="type==0" data-v-d56ea1b0="" class="gamebox">
                  <div data-v-d56ea1b0="" class="longbtn" @click="go2('PG')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/pgdz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('PP')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/ppdz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('CQ9')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/cq9dz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('MGDZ')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/mgdz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('JDB')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/jdbdz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('AGDZ')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/agdz.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('FC')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/ptdz.png" class="main"></div><!---->
              </div>

              <div v-else-if="type==1" data-v-d56ea1b0="" class="gamebox">
                <div data-v-d56ea1b0="" class="longbtn" @click="go2('FB')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/fbty.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('HG')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/xmty.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('IBC')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/imty.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('IM')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/imdj.png"
                        
                        class="main"></div><!---->
            </div>

            <div v-else-if="type==2" data-v-d56ea1b0="" class="gamebox">
                <div data-v-d56ea1b0="" class="longbtn" @click="go2('TCG')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/tccp.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('VRS')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/vrcp.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('IGSS')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/xglhc.png"
                        
                        class="main"></div><!---->
            </div>

            <div v-else-if="type==3" data-v-d56ea1b0="" class="gamebox">
              
              <div data-v-d56ea1b0="" class="longbtn" @click="go2('IM')"><img data-v-d56ea1b0=""
                      
                  
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/imdj.png" class="main"></div><!---->
            </div>
            
            

            <div v-else-if="type==4" data-v-d56ea1b0="" class="gamebox">
              <div data-v-d56ea1b0="" class="longbtn" @click="go2('KY')"><img data-v-d56ea1b0=""
                      
                      src="http://imgtc.qp79799.top/TG@msdj123/wd/kyqp.png" class="main"></div><!---->
                      <div data-v-d56ea1b0="" class="longbtn" @click="go2('DB')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/dbqp.png"
                        
                        class="main"></div><!---->
                        
            </div>

            <div v-else-if="type==5" data-v-d56ea1b0="" class="gamebox">
              <div data-v-787526de="" class="full-hall-game-list">
                <div data-v-d56ea1b0="" class="longbtn" @click="go2('AG')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/agzr.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('BG')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/bgzr.png"
                        
                        class="main"></div><!---->
                        <div data-v-d56ea1b0="" class="longbtn" @click="go2('DB')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/dbzr.png"
                        
                        class="main"></div><!---->
            </div>
            
            </div>
            <div v-else-if="type==6" data-v-d56ea1b0="" class="gamebox">
                <div data-v-d56ea1b0="" class="longbtn" @click="go2('AGBY')"><img data-v-d56ea1b0=""
                        
                        src="http://imgtc.qp79799.top/TG@msdj123/wd/agby.png"
                        
                        class="main"></div><!---->
                       
                        
            </div>
 
           
              


            </div>
          </div>
        </div>
      </div>
      
      <div></div>
      <div style="width: 100%; height: 100%; display: none"><!----><!----></div>
      <!---->
    </div>
    <van-popup v-model:show="lotteryRoomShow" position="bottom">
      <ul>
        <van-empty v-if="lotteryRoom.length == 0" description="当前游戏无房间" />
        <li class="room-item" v-for="i in lotteryRoom" @click="openLotteryRoom(i.id)">
          
          <span>{{ i.lottery.title + " - " + i.title }}</span>
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: true,
      appshow: true,
      goInfo: null,
      scrollTopVal: 0,
      isScroll: 0,
      fliex_top: false,
      status: 0,
      arr_top: [],

      realbetList: [],
      jokerList: [],
      gamingList: [],
      sportList: [],
      lotteryList: [],
      conciseList: [],

      lotteryList: [],
      lotteryRoom: [],
      lotteryRoomShow: false,
      type:0
    };
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    that.getLottery();

    // that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
    //     if (res.code == 200) {
    //       let list = res.data;
    //       let realbetList = [];
    //       let jokerList = [];
    //       let gamingList = [];
    //       let sportList = [];
    //       let lotteryList = [];
    //       let conciseList = [];
    //       list.forEach(el => {
    //         if (el.category_id == 'realbet' && el.app_state == 1) {
    //           realbetList.push(el);
    //         }
    //         if (el.category_id == 'joker' && el.app_state == 1) {
    //           jokerList.push(el);
    //         }
    //         if (el.category_id == 'gaming' && el.app_state == 1) {
    //           gamingList.push(el);
    //         }
    //         if (el.category_id == 'sport' && el.app_state == 1) {
    //           sportList.push(el);
    //         }
    //         if (el.category_id == 'lottery' && el.app_state == 1) {
    //           lotteryList.push(el);
    //         }
    //         if (el.category_id == 'concise' && el.app_state == 1) {
    //           conciseList.push(el);
    //         }
    //         this.realbetList=realbetList
    //         this.jokerList=jokerList
    //         this.gamingList=gamingList
    //         this.sportList=sportList
    //         this.lotteryList=lotteryList
    //         this.conciseList=conciseList
    //         // localStorage.setItem('realbetList', JSON.stringify(realbetList));
    //         // localStorage.setItem('jokerList', JSON.stringify(jokerList));
    //         // localStorage.setItem('gamingList', JSON.stringify(gamingList));
    //         // localStorage.setItem('sportList', JSON.stringify(sportList));
    //         // localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
    //         // localStorage.setItem('conciseList', JSON.stringify(conciseList));

    //       });
    //     }
    //   });
  },
  mounted() {
    this.$nextTick(() => {
      // 开启滚动条监听
      window.addEventListener("scroll", this.scrollTop, true);

      let elVal = document.documentElement.scrollTop || document.body.scrollTop;
      this.isScroll = elVal.scrollHeight > elVal.clientHeight;
    });

    setTimeout(() => {
      this.get_top();
    }, 300);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTop, true);
  },
  methods: {
    go(s){

    },
    getLottery() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post("/api/lotteryList", {})
        .then((res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.lotteryList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch((res) => {
          that.$parent.hideLoading();
        });
    },

    openLottery(name) {
      let _that = this;
      let token = sessionStorage.getItem("token") ? sessionStorage.getItem("token") : "";
      if (!token) {
        _that.$parent.showTost(0, "登录！");
        _that.$parent.showTost(0, "注册！");
        return;
      }

      _that.$parent.showLoading();
      _that.$apiFun
        .post("/api/lotteryRoom", {
          name: name,
        })
        .then((res) => {
          if (res.code != 200) {
            _that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            _that.lotteryRoom = res.data;
            _that.lotteryRoomShow = true;
          }
          _that.$parent.hideLoading();
        })
        .catch((res) => {
          _that.$parent.hideLoading();
        });
    },

    openLotteryRoom(roomid) {
      console.log(`/lottery?room_id=${roomid}`)
      this.lotteryRoomShow = false;
      this.$parent.goNav(`/lottery?room_id=${roomid}`);
    },

    go2(s){
      this.$parent.goNav(`/gamePage?name=${s}&type=0&code=`);
    },

    get_top() {
      this.arr_top = [];
      var box = this.$refs.box1;

      if (box) {
        for (var i = 1; i <= 6; i++) {
          box = this.$refs["box" + i];
          // console.log(box,' 我的')
          // 使用getBoundingClientRect()获取元素的位置信息
          var rect = box.getBoundingClientRect();
          // 计算元素到视口顶部的距离
          var boxTopDistance = rect.top + window.scrollY;
          this.arr_top.push(boxTopDistance - 100);
        }
        console.log(this.arr_top);
      } else {
        setTimeout(() => {
          this.get_top();
        }, 10);
      }
    },
    goscroll(s) {
      // console.log(s)
      document.documentElement.scrollTop = s + 2; // 对于标准模式下的DOCTYPE
    },
    scrollTop() {
      let elVal = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTopVal = elVal;

      if (this.scrollTopVal < this.arr_top[1]) {
        this.status = 0;
      }
      if (this.scrollTopVal > this.arr_top[1]) {
        this.status = 1;
      }
      if (this.scrollTopVal > this.arr_top[2]) {
        this.status = 2;
      }
      if (this.scrollTopVal > this.arr_top[3]) {
        this.status = 3;
      }
      if (this.scrollTopVal > this.arr_top[4]) {
        this.status = 4;
      }
      if (this.scrollTopVal > this.arr_top[5]) {
        this.status = 5;
      }
      // if(this.scrollTopVal>this.arr_top[6]){
      //   this.status=6
      // }
      //
      // console.log(this.scrollTopVal,this.arr_top,this.status)
      if (this.scrollTopVal > 200) {
        this.fliex_top = true;
      } else {
        this.fliex_top = false;
      }
    },
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.gameType = type;
    },
    doCopy(msg) {
      let cInput = document.createElement("input");
      cInput.style.opacity = "0";
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("copy");

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, "复制成功！");
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post("/api/bannerList", { type: 2 })
        .then((res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch((res) => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post("/api/homenotice", {}).then((res) => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },

  updated() {
    let that = this;
  },
};
</script>
<style lang="scss" scoped>
.hallPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
}
.resizable-image {
  display: flex;
    width: 1.2rem;
    height: 1.28rem;
}
.hallPage .head_area,
.hallPage div {
  box-sizing: border-box;
}
.hallPage .head_area {
  width: 100%;
  height: 1.2rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 600;
  position: fixed;
}
.hallPage .head_area .leftImg {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: left;
}
.hallPage .head_area .leftImg .top_logo {
  height: 0.69333rem;
}
.hallPage .head_area .head_text {
  font-size: 0.48rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #0b1028;
  width: 30%;
  text-align: center;
}
.hallPage .head_area .right_menu {
  font-size: 0.37333rem;
  font-family: PingFang SC;
  color: #424653;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-right: 0.13333rem;
}
.hallPage .head_area .right_menu .right_menu_down {
  width: 0.53333rem;
  height: 0.53333rem;
}
.hallPage .head_area .right_menu .right_menu_notice {
  width: auto;
  height: 0.53333rem;
  position: relative;
  right: 0.4rem;
  margin-left: 1.12rem;
}
.hallPage .head_area .right_menu .right_menu_notice .right_menu_notice_img {
  position: absolute;
  width: 0.53333rem;
  height: 0.53333rem;
  left: 0;
}
.hallPage .head_area .right_menu .right_menu_notice .unreadNum {
  position: absolute;
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 50%;
  background: #f18e56;
  left: 0.45333rem;
  top: -0.02667rem;
}
.hallPage div::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
.hallPage .colosline {
  width: 100%;
  height: 0.08rem;
  background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
  background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.hallPage .zoom {
  -webkit-transform: scale(0.8) translateX(-0.34667rem);
  -ms-transform: scale(0.8) translateX(-0.34667rem);
  transform: scale(0.8) translateX(-0.34667rem);
}
.hallPage .doge {
  width: 3.73333rem;
  height: 1.92rem;
  margin-top: 0.21333rem;
  border-radius: 0.10667rem;
}
.hallPage .maincontent {
  width: 100%;
  padding-top: 1.2rem;
  height: calc(100% - 1.2rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
.hallPage .hallinner {
  // padding-bottom: 0.5rem;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.hallPage .hallinner .gif_loading {
  widows: 1.33333rem;
  height: 1.33333rem;
}
.hallPage .toppart {
  background: #fff;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.hallPage #showdot,
.hallPage .toppart {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.hallPage #showdot {
  height: 0.08rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: 0.2rem;
  left: 0;
  z-index: 400;
}
.hallPage #showdot div {
  width: 0.26667rem;
  height: 0.08rem;
  font-size: 0;
  color: transparent;
  margin-right: 0.13333rem;
  background: #d2d3db;
}
.hallPage #showdot .active {
  background: #fca954;
}

.hallPage .outerbox {
  width: 9.2rem;
  height: 3.86667rem;
  margin-top: 0.10667rem;
  margin-left: 0.4rem;
  position: relative;
  background: #fff;
  border-radius: 0.13333rem;
  overflow: hidden;
  margin-bottom: 0.13333rem;
}
.hallPage .outerbox .transbox {
  width: 20000%;
  height: 3.86667rem;
  position: absolute;
}
.hallPage .outerbox .transbox div,
.hallPage .outerbox .transbox div img {
  width: 9.2rem;
  height: 3.86667rem;
  border-radius: 0.13333rem;
}
.hallPage .noticecontent {
  box-sizing: border-box;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 9.2rem;
    height: 0.93333rem;
    background: #f4f6fa;
    border: 0.02667rem solid #fff;
    box-shadow: 0 0.08rem 0.21333rem 0 rgb(75 106 184 / 18%);
    border-radius: 0.26667rem;
    margin: 0.26667rem auto;
    padding-left: 0.4rem;
    padding-right: 0.26667rem;
    overflow: hidden;
    margin-top: 3px;
}
.hallPage .noticecontent img {
  width: 0.37333rem;
  height: 0.37333rem;
}
.hallPage .noticecontent .noticect {
  width: 8.61333rem;
  margin-left: 0.18667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.hallPage .noticecontent .noticect .van-notice-bar {
  width: 100%;
  padding-right: 0;
  padding-left: 0;
  background: #f5f8fd;
  
}
.hallPage .noticecontent .noticect .van-notice-bar .van-notice-bar__wrap {
  background: #fff;
}
.hallPage .noticecontent .noticect .van-notice-bar .van-notice-bar__wrap span {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #535a73;
}
.hallPage .noticecontent .noticect .van-notice-bar h1,
.hallPage .noticecontent .noticect .van-notice-bar h2,
.hallPage .noticecontent .noticect .van-notice-bar h3,
.hallPage .noticecontent .noticect .van-notice-bar h4,
.hallPage .noticecontent .noticect .van-notice-bar h5,
.hallPage .noticecontent .noticect .van-notice-bar h6,
.hallPage .noticecontent .noticect .van-notice-bar i,
.hallPage .noticecontent .noticect .van-notice-bar p {
  font-size: 0.32rem !important;
  font-weight: 400 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.hallPage .centerArea {
  width: 100%;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 9.2rem;
    height: 1.7rem;
    background: #f4f6fa;
    border: 0.02667rem solid #fff;
    box-shadow: 0 0.08rem 0.21333rem 0 rgb(75 106 184 / 18%);
    border-radius: 0.26667rem;
    margin: 0 auto;
    padding-left: 0.4rem;
    padding-right: 0.26667rem;
    margin-bottom: 0.26667rem;
}
.hallPage .centerArea .left_content {
  width: 4.42667rem;
  transform: translateX(3px);
}
.hallPage .centerArea .left_content .logindd {
  width: 100%;
  height: 0.4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.34667rem;
  font-family: DIN;
  font-weight: 500;
  color: #7e88ad;
}
.hallPage .centerArea .left_content .logindd .level_img {
  width: 1.06667rem;
  height: 0.42667rem;
  margin-right: 0.08rem;
}
.hallPage .centerArea .left_content .logindd1 {
  font-size: 0.34667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #4a5c95;
}
.hallPage .centerArea .left_content .logindd2 {
  font-size: 0.53333rem;
  font-family: DIN;
  font-weight: 500;
  color: #0b1028;
  margin-top: 0.26667rem;
}
.hallPage .centerArea .left_content .logindd2 .money_text {
  width: 0.4rem;
  height: 0.34667rem;
  margin-left: 0.21333rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAMAAACXfxyGAAAAdVBMVEUAAABrcY1rco1rco1ibIVqcY1rco1qcY1mcYpjZoprcoxrco1qcY1qcoxqcY1pcItpcYxrco1rco1rcYxrcYtscItrcYxmb4pocohrco1rco1rcI5nbotqcY1qcY1qcY1qcY1qcYxqco1rco1qcY5rcY5rco05ByIuAAAAJnRSTlMA9frhCH16YxQO7s+wqHNCN725UichHx0ZysNbI9KhjYZH6Z1sKx8eOj8AAADxSURBVCjPfZPXkoQgEAABMWfX7MYL/f+feLd6egq12y8M1RQzQw3in9otHSmdKuuFzTlhRV070/qSHdFk6AgYsqLtimwA8I46wcnX+OEA/kHrQouNcAT1LV6iYxjXjetavpGQ/4VKNpa/Q7pEJZSW7kDquWMA3/IxFL9LEAFEgamvMD0bVoBSyVH2wQ2yoBeh9uCuw6NOmUmX5J/CIPzYUuYQC5MTwDSfVNBaPoFqiSq4WbqXstsuUmfLZ97uCS5avKQAxmBXd330X4Dz2Kp2zGFxAWI3r+vcvQDD21GUJ2HQpoqVtBU2jVc9v0Hp7Zr8AchkGzI4vNXyAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}
.hallPage .centerArea .left_content .toptit {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #7e88ad;
  margin-bottom: 0.18667rem;
}
.hallPage .centerArea .left_content .btnArea {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 0.66667rem;
}
.hallPage .centerArea .left_content .btnArea .btn_item1 {
  background: -webkit-linear-gradient(left, #f08448, #ffc170);
  background: linear-gradient(90deg, #f08448, #ffc170);
  border-radius: 0.34667rem;
  color: #fff;
}
.hallPage .centerArea .left_content .btnArea .btn_item1,
.hallPage .centerArea .left_content .btnArea .btn_item2 {
  min-width: 1.46667rem;
  height: 0.66667rem;
  font-size: 0.37333rem;
  font-family: PingFang SC;
  font-weight: 700;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.hallPage .centerArea .left_content .btnArea .btn_item2 {
  background: #fff;
  border: 0.02667rem solid #f39151;
  border-radius: 0.34667rem;
  margin-left: 0.13333rem;
  color: #ff8439;
}
.hallPage .centerArea .right_content,
.hallPage .centerArea .right_content .right_item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.hallPage .centerArea .right_content .right_item {
  margin-right: 0.21333rem;
  height: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.hallPage .centerArea .right_content .right_item img {
  width: 0.80667rem;
  height: 0.84667rem;
}
.hallPage .centerArea .right_content .right_item .right_item_span {
  font-size: 0.29333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #424653;
  margin-top: 6px;
}
.hallPage .centerArea .right_content .right_item:last-child {
  margin-right: 0;
}

.hallPage .line {
  width: 10rem;
  height: 0.08rem;
  background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
  background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}

.activebox {
  width: 1.6rem;
  position: fixed;
  bottom: 2.24rem;
  right: 0.13333rem;
  z-index: 1000;
}
.activebox .activebox_wrap {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.activebox .activebox_wrap .activebox_main_banner {
  width: 1.6rem;
  height: 1.76rem;
  position: relative;
}
.activebox .activebox_wrap .activebox_main_banner .activity-main {
  width: 100%;
}
.activebox .activebox_wrap .activebox_main_banner .close-btn {
  width: 1.06667rem;
  height: 0.42667rem;
  margin: 0 auto;
  position: absolute;
  bottom: -0.42667rem;
  left: 0.26667rem;
}
.activebox .activebox_wrap .needMargin {
  margin-top: 0.53333rem !important;
  margin-bottom: 0.53333rem !important;
}
.activebox .activebox_wrap .activity-box {
  margin-top: 0.26667rem;
  margin-bottom: 0.13333rem;
  max-height: 7.2rem;
  position: relative;
}
.activebox .activebox_wrap .activity-box .swiper-button-prev {
  width: 0.42667rem;
  height: 0.21333rem;
  position: absolute;
  top: -0.34667rem;
  left: 50%;
  margin-left: -0.21333rem;
}
.activebox .activebox_wrap .activity-box .swiper-button-next {
  width: 0.42667rem;
  height: 0.21333rem;
  position: absolute;
  bottom: -0.34667rem;
  left: 50%;
  margin-left: -0.21333rem;
}
.activebox .activebox_wrap .activity-box .swiper-container {
  max-height: 6.93333rem !important;
  overflow: hidden;
}
.activebox .activebox_wrap .activity-box .swiper-container .swiper-wrapper {
  height: auto !important;
}
.activebox .activebox_wrap .activity-box .activity-item,
.activebox .activebox_wrap .activity-box .swiper-container .swiper-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.activebox .activebox_wrap .activity-box .activity-item {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 1.2rem !important;
  margin-bottom: 0.21333rem !important;
}
.activebox .activebox_wrap .activity-box .activity-item img {
  height: 1.2rem;
  width: 1.2rem;
}
.activebox .activebox_wrap .activity-box .activity-item .activity-tit {
  font-size: 0.32rem;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  margin-top: 0.13333rem;
  max-width: 1.33333rem;
  height: 0.32rem;
}
.activebox .activebox_wrap .activity-box .activity-item .activity-tit .van-notice-bar {
  background: none;
  height: 0.32rem;
  width: 1.33333rem;
  padding: 0;
  color: #fff;
}
.activebox
  .activebox_wrap
  .activity-box
  .activity-item
  .activity-tit
  .van-notice-bar__content {
  color: #fff;
  font-size: 0.32rem;
}
.activety_open {
  max-height: 10.26667rem;
  background-color: rgba(242, 243, 246, 0.8);
  border-radius: 0.8rem;
  opacity: 1;
}
.withdrawCheckPop {
  width: 7.46667rem;
  background: #fff;
  border-radius: 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}
.withdrawCheckPop .flag {
  width: 3.65333rem;
  height: 0.13333rem;
  background: #3084ff;
  margin: 0 auto;
}
.withdrawCheckPop .logoimg {
  height: 0.64rem;
  display: block;
  margin: 0 auto;
  margin-top: 0.66667rem;
  margin-bottom: 0.34667rem;
}
.withdrawCheckPop .center_text {
  min-height: 2.72rem;
  line-height: 0.56rem;
  font-size: 0.37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #424653;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.withdrawCheckPop .b_btnList,
.withdrawCheckPop .center_text {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.withdrawCheckPop .b_btnList {
  height: 1.2rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-top: 0.02667rem solid #e1e1e1;
}
.withdrawCheckPop .b_btnList .item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #424653;
  text-align: center;
}
.withdrawCheckPop .b_btnList .item:last-child {
  color: #fff;
  background: #3084ff;
  border-radius: 0 0 0.26667rem 0;
}
.van-swipe {
  height: 100%;
}

.room-item {
  position: relative;
  width: calc(98% - 60px);
  margin: 0 auto;
  height: 60px;
  text-align: left;
  line-height: 60px;
  font-size: 0.4rem !important;
  font-weight: bold;
  border-bottom: 1px solid #d1d1d1;
  padding-left: 60px;
}

.room-item:last-child {
  border-bottom: 0;
}

.room-item img {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 10px;
  top: 10px;
}

.loginbtn {
  width: 1.46667rem;
    height: .66667rem;
    background-size: 100% 100%;
  background-image: url(https://wswds3.shranshen.com/h5_static/wd/img/denglu.2f9b07eb.png);
  
}
.loginbtn1 {
     background-image: url(https://wswds3.shranshen.com/h5_static/wd/img/zhuce.5eb10ef3.png);
  width: 1.46667rem;
    height: .66667rem;
    background-size: 100% 100%;
    transform: translateX(115%);
}
.mey{
  width: 200px;
    margin-top: 3px;
    color: #4a5c95;
    
}
.gamenavs {
    width: 100%;
    height: 54px;
    top: .9rem;
    left: 0;
    z-index: 600;
    background: #fff;
    padding-top: .26667rem;
    
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    margin-top: -10px;
}
.gamenavs .gamenav {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/dz.png);
}
.gamenavs .gamenav1 {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/ty.png);
}
.gamenavs .gamenav2 {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/cp.png);
}
.gamenavs .gamenav3 {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/dj.png);
}
.gamenavs .gamenav4 {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/zr.png);
}
.gamenavs .gamenav5 {
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/qp.png);
    
}
.gamenavs .gamenav6{
  height: 45PX;
    width: 13%;
    margin-left: 1%;
    margin-bottom: 0.5%;
    line-height: 2.0rem;
    color: #6e6e6e;
    position: relative;
    padding: 0.01rem;
    background-size: cover;
    display: inline-block;
    text-align: center;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/by.png);
}
.gamenavs .gamenavac {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/dzl.png);
    background-size: 44px 47px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac1 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/tyl.png);
    background-size: 44px 47px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac2 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/cpl.png);
    background-size: 48px 50px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac3 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/djl.png);
    background-size: 44px 47px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac4 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/zrl.png);
    background-size: 48px 50px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac5 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/qpl.png);
    background-size: 44px 47px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}
.gamenavs .gamenavac6 {
  color: #ffffff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/byl.png);
    background-size: 44px 47px;
    background-repeat: no-repeat;
    transform: translateY(10px);
    width: 47px;
    height: 66px;
}







.hall div::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none
}

.hall .colosline {
    width: 100%;
    height: .08rem;
    background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
    background: linear-gradient(90deg, #f08448, #ffce70, #f08449)
}

.hall .zoom {
    -webkit-transform: scale(.8) translateX(-.34667rem);
    -ms-transform: scale(.8) translateX(-.34667rem);
    transform: scale(.8) translateX(-.34667rem)
}

.hall .doge {
    width: 3.73333rem;
    height: 1.92rem;
    margin-top: .21333rem;
    border-radius: .10667rem
}

.hall .maincontent {
    width: 100%;
    height: calc(100% - .64rem);
    overflow-x: hidden;
    overflow-y: scroll
}

.hall .hallinner {
    padding-bottom: 1.97333rem;
    width: 100%
}

.hall .hallinner .gif_loading {
    widows: 1.33333rem;
    height: 1.33333rem
}

.hall .toppart {
    width: 100%;
    background: #fff;
    margin-top: -.10667rem;
    padding-top: .10667rem
}

.hall #showdot {
    width: 100%;
    height: .08rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: absolute;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    bottom: .2rem;
    left: 0;
    z-index: 400
}

.hall #showdot div {
    width: .26667rem;
    height: .08rem;
    font-size: 0;
    color: transparent;
    margin-right: .13333rem;
    background: #d2d3db
}

.hall #showdot .active {
    background: #fca954
}

.hall .head_area {
    width: 100%;
    height: 1.2rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding-left: .4rem;
    padding-right: .4rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    box-sizing: border-box;
    background: #fff;
    top: 0;
    left: 0;
    z-index: 600
}

.hall .head_area .leftImg {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: left
}

.hall .head_area .leftImg .top_logo {
    height: .69333rem
}

.hall .head_area .head_text {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #0b1028;
    width: 30%;
    text-align: center
}

.hall .head_area .right_menu {
    font-size: .37333rem;
    font-family: PingFang SC;
    color: #424653;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-right: .13333rem
}

.hall .head_area .right_menu .right_menu_down {
    width: .53333rem;
    height: .53333rem
}

.hall .head_area .right_menu .right_menu_notice {
    width: auto;
    height: .53333rem;
    position: relative;
    right: .4rem;
    margin-left: 1.12rem
}

.hall .head_area .right_menu .right_menu_notice .right_menu_notice_img {
    position: absolute;
    width: .53333rem;
    height: .53333rem;
    left: 0
}

.hall .head_area .right_menu .right_menu_notice .unreadNum {
    position: absolute;
    width: .16rem;
    height: .16rem;
    border-radius: 50%;
    background: #f18e56;
    left: .45333rem;
    top: -.02667rem
}

.hall .outerbox {
    width: 9.2rem;
    height: 3.86667rem;
    margin-top: .10667rem;
    margin-left: .4rem;
    overflow: hidden;
    position: relative;
    background: #fff
}

.hall .outerbox .transbox {
    width: 20000%;
    height: 3.86667rem;
    position: absolute
}

.hall .outerbox .transbox div,
.hall .outerbox .transbox div img {
    width: 9.2rem;
    height: 3.86667rem;
    border-radius: .13333rem
}

.hall .noticecontent {
    width: 100%;
    height: .66667rem;
    box-sizing: border-box;
    padding: 0 .4rem;
    margin-top: .13333rem;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .noticecontent img {
    width: .33333rem;
    height: .33333rem
}

.hall .noticecontent .noticect {
    width: 8.61333rem;
    height: .66667rem;
    margin-left: .13333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .noticecontent .noticect .van-notice-bar {
    width: 100%;
    height: .66667rem;
    line-height: .66667rem;
    font-size: .34667rem;
    background: #fff;
    color: #9ca3bf;
    font-weight: 400;
    padding-right: 0;
    padding-left: 0
}

.hall .noticecontent .noticect .van-notice-bar h1,
.hall .noticecontent .noticect .van-notice-bar h2,
.hall .noticecontent .noticect .van-notice-bar h3,
.hall .noticecontent .noticect .van-notice-bar h4,
.hall .noticecontent .noticect .van-notice-bar h5,
.hall .noticecontent .noticect .van-notice-bar h6,
.hall .noticecontent .noticect .van-notice-bar i,
.hall .noticecontent .noticect .van-notice-bar p {
    font-size: .34667rem !important;
    font-weight: 400 !important;
    margin: 0 !important;
    padding: 0 !important
}

.hall .inavbtns {
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: .26667rem .4rem .48rem .4rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .inavbtns .leftind {
    width: 4.42667rem
}


.hall .inavbtns .leftind .logindd {
    width: 100%;
    height: .4rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .inavbtns .leftind .logindd:first-child {
    color: #9ca3bf;
    font-size: .34667rem;
    margin-top: .08rem;
    font-weight: 500
}

.hall .inavbtns .leftind .logindd:first-child img {
    width: .8rem;
    height: .4rem;
    margin-right: .2rem
}

.hall .inavbtns .leftind .logindd:nth-child(2) {
    height: .53333rem;
    font-size: .53333rem;
    margin-top: .22667rem;
    font-weight: 500
}

.hall .inavbtns .leftind .logindd:nth-child(2) div {
    width: .34667rem;
    height: .30667rem;
    margin-left: .26667rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAADhUlEQVRIS5VVXWgcVRT+zp1NUiqpUkRfpKDFh6KUKqFttGYzm0qgiFqFKLqzSbuzXWJhqQo++FAnvhQfWvCh2N2dNWZ248OKfwhi0s1OjBWL7VNqFUEFMQV/sNSirZvu3CNJuunszp24ncd7vp9zzzlzLuEmvrwzdbcQXY8x0M+SOzs65aGRZwd+bEeC2gBRrjTzJLHIEBC9jj/qXel+NZ3uudYGfxmyplFu0t0mPM6CaPuKIEtITpvDA3a7Bg1cqFFh0h1hDydA6GqApeSXDwzHjoWZWJYb2bjx6vpMZs/lVozSKF+cGSWI4803pmnT6B8MMykUPu6WnRvmwLxFCO3xZDw67ccGjN52qlGPqEJAxAdk1rRtqef65lVGzEx2afZ9AvauNIQugnmHaeg/KEtXLpc7//r39m+JaLNfkIEzKUO/3qeglV2qHgbTWBOHcX5xHXYeHNL/DgyDXXRNAPlWKQbGUoZuqW6Tn6g+QUJ8ALBQ8D404/1PExE3lc4uul8B2KkQ3Gsa+ket53nn8y1EfBrgDaFTyPyamYi9vmqULZ+8Vat1XFRmRuhNxfXTfrHxcfc2L4KvAdy79qiTZCmfWjWyS9WHwXRKRfKovjUdf/ScP5Zzqm8Iolfa+Z8I9DvZkzN98HAnhNYDZiWRWb5IwAUimk8ase+XxLMTJzdpJHawEJuJcUQ5jVKOEeG8JFygfHH2ZwJvaiczML9rJmLP+7HZCXeXJvCFshL1+tb0vpVKUGGi0itJc8m3AUJMf2NCTyquL7SUcFAQfRbgMGre1e7uxj5c7lHYWN8g0yKjvjtl7A5kbpfcYTDeCSbH06YRW90kN4ahWD0O0Auq20jG6IGEfkIVs4uzRwF+qTVG4GeSRqwc2AzZ7NkObf3lCkB9fhKBckmjPx3Ww7zjfkOE+5rizPMLP+kPWBbJgNHSwVvO1B0R6jhDoMZwfLnQ9UfMGhpaVG6FYuURgjbnjzGjJoBdyYR+tjnhFoVsceZBDeQC9GetjocO7tN/VZlYliXuuid6CoReX9wjYDhp6JPBUipUHGfqlkuXvHoms6cWVrKcUx0TRId9A3MF7I2YiYH3VJx2nvIAr1ByDzFj6QFc5jMv/UcinUpEvwtL7KaMxsfddfUIHyPQ6PKzDlSY8WYqEfs0zEA5DGuBbce9nwSOsMQ/knku4l37ZP/+wV/+z6AR/w/qI0+N/ewu/QAAAABJRU5ErkJggg==) no-repeat;
    background-size: 100% 100%
}

.hall .inavbtns .leftind .toptit {
    height: .32rem;
    font-size: .32rem;
    color: #9ca3bf;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .inavbtns .leftind .botbutton,
.hall .inavbtns .leftind .toptit {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.hall .inavbtns .leftind .botbutton {
    height: .66667rem;
    margin-top: .18667rem
}

.hall .inavbtns .leftind .botbutton div {
    width: 1.46667rem;
    height: .66667rem;
    border-radius: .33333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: #fff;
    font-size: .37333rem
}

.hall .inavbtns .leftind .botbutton .lfbut {
    background: -webkit-linear-gradient(left, #f08448, #ffc170);
    background: linear-gradient(90deg, #f08448, #ffc170)
}

.hall .inavbtns .leftind .botbutton .rtbut {
    border: .02667rem solid #f39151;
    color: #ff8439;
    margin-left: .26667rem
}

.hall .inavbtns .leftind .rotate {
    -webkit-animation: rotation 2s linear infinite;
    animation: rotation 2s linear infinite
}

@-webkit-keyframes rotation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    to {
        -webkit-transform: rotate(2359deg);
        transform: rotate(2359deg)
    }
}

@keyframes rotation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    to {
        -webkit-transform: rotate(2359deg);
        transform: rotate(2359deg)
    }
}

.hall .inavbtns .rightind,
.hall .inavbtns .rightind .secondbtn {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.hall .inavbtns .rightind .secondbtn {
    height: 1.30667rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: .36rem
}

.hall .inavbtns .rightind .secondbtn img {
    width: .90667rem;
    height: .94667rem
}

.hall .inavbtns .rightind .secondbtn div {
    width: 100%;
    height: .26667rem;
    font-size: .32rem;
    color: #424653;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: .05333rem;
    font-weight: 500;
    font-family: 微软雅黑
}

.hall .inavbtns .rightind .secondbtn:last-child {
    margin-right: 0
}

.hall .gamenavs {
    width: 100%;
    height: 1.08rem;
    top: .9rem;
    left: 0;
    z-index: 600;
    background: #fff;
    padding-top: .26667rem;
    overflow-x: scroll
}

.hall .gamenavs,
.hall .gamenavs .gamenav {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .gamenavs .gamenav {
    height: .81333rem;
    position: relative;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-bottom: .02667rem;
    padding-left: .21333rem;
    padding-right: .21333rem;
    line-height: .81333rem;
    color: #424653;
    font-size: .34667rem;
    z-index: 300;
    top: 0;
    font-weight: 500
}

.hall .gamenavs .gamenavac {
    color: #fff;
    background-image: url(http://imgtc.qp79799.top/TG@msdj123/wd/navbg_gz.0842e08b.png);
    background-size: 100% .8rem;
    transform: translateY(7px);
    background-position: center .02667rem;
    background-repeat: no-repeat
}

.hall .gamebox {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    padding: .26667rem 0 0 .26667rem
}

.hall .gamebox .expectation {
    width: 100%;
    height: 3.6rem;
    padding-bottom: .26667rem
}

.hall .gamebox .expectation img {
    margin-left: .13333rem;
    width: 9.2rem
}

.hall .gamebtn {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 4.6rem;
    height: 1.73333rem;
    background-color: #f7f8fd;
    box-shadow: 0 .05333rem .10667rem 0 rgba(87,92,115,.1);
    border-radius: .13333rem;
    margin: 0 .26667rem .26667rem 0;
    position: relative
}

.hall .gamebtn .galt {
    width: 1.4rem;
    height: 1.4rem;
    margin: .26667rem;
    
}

.hall .gamebtn .scpng {
    position: absolute;
    width: .5rem;
    height: .5rem;
    top: 2px;
    right: 4px;
    z-index: 300
}

.hall .gamebtn .gamert {
    width: 2.85333rem;
    height: 1.73333rem
}

.hall .gamebtn .gamert div {
    width: 100%;
    height: .32rem;
    font-size: .32rem;
    white-space: nowrap;
    color: #424653;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.hall .gamebtn .gamert div:first-child {
    margin-top: .48rem
}

.hall .gamebtn .gamert div:nth-child(2) {
    margin-top: .18667rem;
    font-size: .26667rem;
    color: #9ca3bf
}

.hall .gamebtn .gamert div:nth-child(2) font {
    color: #ff8439
}

.hall .longbtn {
    width: 9.46667rem;
    height: 2.98667rem;
    margin: 0 .26667rem .26667rem 0;
    border-radius: .13333rem;
    overflow: hidden;
}

.hall .longbtn .scpng {
    position: absolute;
    width: .94667rem;
    height: .94667rem;
    top: 0;
    right: 0;
    z-index: 300
}

.hall .longbtn .main {
    width: 100%
}

.hall .longbtn div {
    width: 100%;
    height: .32rem;
    font-size: .32rem;
    color: #424653;
    position: absolute;
    box-sizing: border-box;
    padding-left: .26667rem;
    left: 0;
    top: .26667rem;
    font-weight: 500;
    z-index: 200
}

.hall .longbtn div:nth-child(3) {
    top: .8rem;
    font-size: .26667rem;
    color: #9ca3bf
}

.hall .longbtn div:nth-child(3) font {
    color: #cc6a74
}

.hall .longbtn img {
    max-height: 100%
}

.hall .midbtn {
    width: 4.58667rem;
    margin-right: .26667rem;
    height: 2.93867rem
}

.hall .activeitilt {
    height: 1.06667rem;
    color: #424653;
    font-size: .34667rem;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background: #fff;
    box-shadow: 0 0 .16rem 0 rgba(159, 170, 202, .35)
}

.hall .activeitilt img {
    width: 2.2rem;
    margin-right: .10667rem;
    // margin-top: .16rem;
    margin-left: .4rem
}

.hall .activebox1 {
    padding: .26667rem 0 0 .26667rem;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.hall .activebox1,
.hall .activebox1 .gamebtn {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.hall .activebox1 .gamebtn:last-child .galt {
    margin-top: .26667rem
}

.withdrawCheckPop {
    width: 7.46667rem;
    background: #fff;
    border-radius: .24rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    overflow: hidden
}

.withdrawCheckPop .flag {
    width: 3.65333rem;
    height: .13333rem;
    background: -webkit-linear-gradient(left, #f08448, #ffc170);
    background: linear-gradient(90deg, #f08448, #ffc170);
    margin: 0 auto
}

.withdrawCheckPop .logoimg {
    height: .64rem;
    display: block;
    margin: 0 auto;
    margin-top: .66667rem;
    margin-bottom: .34667rem
}

.withdrawCheckPop .center_text {
    min-height: 2.72rem;
    line-height: .56rem;
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #424653;
    white-space: pre-wrap;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center
}

.withdrawCheckPop .b_btnList,
.withdrawCheckPop .center_text {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.withdrawCheckPop .b_btnList {
    height: 1.2rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    border-top: .02667rem solid #e1e1e1
}

.withdrawCheckPop .b_btnList .item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: .42667rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #424653;
    text-align: center
}

.withdrawCheckPop .b_btnList .item:last-child {
    color: #fff;
    background: -webkit-linear-gradient(left, #f08448, #ffc170);
    background: linear-gradient(90deg, #f08448, #ffc170);
    border-radius: 0 0 .26667rem 0
}

.activebox2 {
    width: 1.6rem;
    position: fixed;
    bottom: 2.24rem;
    right: .13333rem;
    z-index: 1000
}

.activebox2 .activebox_wrap {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between
}

.activebox2 .activebox_wrap .activebox_main_banner {
    width: 1.6rem;
    position: relative
}

.activebox2 .activebox_wrap .activebox_main_banner .activity-main {
    width: 100%
}

.activebox2 .activebox_wrap .activebox_main_banner .close-btn {
    width: 1.06667rem;
    height: .42667rem;
    margin: 0 auto;
    position: absolute;
    bottom: -.42667rem;
    left: .26667rem
}

.activebox2 .activebox_wrap .needMargin {
    margin-top: .53333rem !important;
    margin-bottom: .53333rem !important
}

.activebox2 .activebox_wrap .activity-box {
    margin-top: .26667rem;
    margin-bottom: .13333rem;
    max-height: 7.2rem;
    position: relative
}

.activebox2 .activebox_wrap .activity-box .swiper-button-prev {
    width: .42667rem;
    height: .21333rem;
    position: absolute;
    top: -.34667rem;
    left: 50%;
    margin-left: -.21333rem
}

.activebox2 .activebox_wrap .activity-box .swiper-button-next {
    width: .42667rem;
    height: .21333rem;
    position: absolute;
    bottom: -.34667rem;
    left: 50%;
    margin-left: -.21333rem
}

.activebox2 .activebox_wrap .activity-box .swiper-container {
    max-height: 6.93333rem !important;
    overflow: hidden
}

.activebox2 .activebox_wrap .activity-box .activity-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 1.2rem !important;
    margin-bottom: .21333rem !important
}

.activebox2 .activebox_wrap .activity-box .activity-item img {
    height: 1.2rem;
    width: 1.2rem
}

.activebox2 .activebox_wrap .activity-box .activity-item .activity-tit {
    font-size: .32rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    margin-top: .13333rem;
    max-width: 1.33333rem;
    height: .32rem
}

.activebox2 .activebox_wrap .activity-box .activity-item .activity-tit .van-notice-bar {
    background: none;
    height: .32rem;
    width: 1.33333rem;
    padding: 0;
    color: #fff
}

.activebox2 .activebox_wrap .activity-box .activity-item .activity-tit .van-notice-bar__content {
    color: #fff;
    font-size: .32rem
}

.activety_open {
    max-height: 10.26667rem;
    background-color: rgba(242, 243, 246, .8);
    border-radius: .8rem;
    opacity: 1
}

.hall-head[data-v-787526de] {
  position: relative;
  height: 1.17333rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
}
.hall-head > img[data-v-787526de] {
  height: .88rem;
  border-radius: .53333rem;
  margin-left: .26667rem;
  margin-top: .13333rem;
  width: .88rem;
}
.accounts-head-text[data-v-787526de] {
  font-size: .48rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: #1d2548;
  text-align: center;
  line-height: 1.2rem;
  font-family: PingFang SC;
  font-weight: 700;
}
.download-link[data-v-787526de] {
  width: 2.56rem;
  margin-top: .32rem;
  margin-right: .32rem;
}
.download-link img[data-v-787526de] {
  width: 100%;
}

.full-hall-game-list[data-v-787526de] {
    padding-bottom: .26667rem;
    background: #fff;
}
.full-hall-game-list .hall-game-list-details[data-v-787526de] {
    width: 9.46667rem;
    height: 3.57333rem;
    background: #fff;
    display: inline-flex;
    margin: .26667rem .26667rem;
    margin-right: 0;
    margin-bottom: 0;
    border-radius: .13333rem;
    box-shadow: 0 .05333rem .10667rem 0 rgba(87, 92, 115, .1);
    position: relative;
}
.hall-game-list-details>img[data-v-787526de] {
    width: 100%;
    height: 100%;
}
.hall-game-list-details .hall-game-text01[data-v-787526de] {
    font-size: .37333rem;
    color: #2f3242;
    font-family: PingFang-SC-Medi;
    display: inline-block;
    width: 2.26667rem;
    margin: 0 0;
    padding-top: .4rem;
    padding-left: .26667rem;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue